window.BorderCell = function () {
    var el = this;
    var borderColor = '#ffffff';
    var frames = [];

    function init() {
        var cell = el._parent.workData.workareas[el.selectWorkareaId].cells[el.selectId];

        borderColor = cell.border_color;

        var templateData = {
            groups: [],
            attributes: {
                thickness: cell.x - cell.border_x,
                shadow: cell.hasOwnProperty('border_shadow') ? cell.border_shadow : 2,
                opacity: cell.hasOwnProperty('border_opacity') ? cell.border_opacity : 1
            }
        };

        for (var i in frames) {
            var templateFramesGroup = {id: 0, name: '', frames: []};
            for (var j in frames[i]) {
                var frame = frames[i][j];
                var image = frame[Object.keys(frame)[0]];
                templateFramesGroup.name = image.group_name;
                templateFramesGroup.id = image.frame_id;
                templateFramesGroup.frames.push(image);
            }
            templateData.groups.push(templateFramesGroup);
        }

        // var output = window.Mustache.render($('#frames-template').html(), templateData);
        // $('#borders-content').html(output);

        var color = cell.hasOwnProperty('border_color') ? cell.border_color : '#ffffff';
        $('#border-color').colpick({
            color: color.split('#').join(''),
            submit: 0,
            onChange: el.borderCell.setColor
        }).css('background-color', color);
    }

    function update(attributes, apply) {
        switch (apply) {
            case 0:
                updateElements(attributes, el.selectWorkareaId, el.selectId);
                //el.mask.updateMask(attributes.company_id, attributes.mask, el.mode, el.selectWorkareaId, el.selectId);
                break;
            case 1:
                var reversals = el._parent.workData.workareas;
                var reversalId, cellId;
                for (reversalId in reversals) {
                    var reversal = reversals[reversalId];
                    for (cellId in reversal.cells) {
                        if (reversal.images.hasOwnProperty(cellId) && reversal.images[cellId] !== null && !reversal.images[cellId].hasOwnProperty('mask') || !reversal.images.hasOwnProperty(cellId)) {
                            updateElements(attributes, reversalId, cellId);
                            //el.mask.updateMask(attributes.company_id, attributes.mask, 'reversals', reversalId, cellId);
                        }
                    }
                }
                
                el.lastBorderAttributes = attributes;
                break;
        }
    }

    function updateElements(attributes, reversalId, cellId) {
        el._parent.svgRoot = document.getElementById('constructor-hardcover');
        var element = el.svgRoot.getElementById('border-item-' + reversalId + '-' + cellId);
        var shadowElement = el.svgRoot.getElementById('shadow-cell-' + reversalId + '-' + cellId + '-thickness');
        var imageBorder = el.svgRoot.getElementById('border-image-' + reversalId + '-' + cellId);
        var cell = el._parent.workData.workareas[reversalId].cells[cellId];

        if (cell !== null) {
            cell = el.updateData(attributes, cell);
            el.history.add();
            var type;
            for (type in attributes) {
                switch (type) {
                    case 'thickness':
                        if (element) {
                            element.setAttribute('x', cell.border_x);
                            element.setAttribute('y', cell.border_y);
                            element.setAttribute('width', cell.border_width);
                            element.setAttribute('height', cell.border_height);
                        }
                        if (imageBorder) {
                            imageBorder.setAttribute('x', cell.border_x);
                            imageBorder.setAttribute('y', cell.border_y);
                            imageBorder.setAttribute('width', cell.border_width);
                            imageBorder.setAttribute('height', cell.border_height);
                        }
                        break;
                    case 'shadow':
                        if (shadowElement) {
                            shadowElement.setAttribute('stdDeviation', cell.border_shadow);
                        }
                        break;
                    case 'opacity':
                        if (element) {
                            element.setAttribute('fill-opacity', cell.border_opacity);
                        }
                        break;
                    case 'color':
                        if (element) {
                            element.setAttribute('fill', cell.border_color);
                        }
                        break;
                }

                $('#border-' + type + '-value').text(attributes[type]);
                $('.js-apply-border[data-type="' + type + '"]').val(attributes[type]);
            }
        }
    }

    el.updateData = function (attributes, cell) {
        for (var type in attributes) {
            switch (type) {
                case 'thickness':
                    cell.border_x = parseInt(cell.x) - attributes.thickness;
                    cell.border_y = parseInt(cell.y) - attributes.thickness;
                    cell.border_width = parseInt(cell.width) + 2 * attributes.thickness;
                    cell.border_height = parseInt(cell.height) + 2 * attributes.thickness;
                    break;
                case 'shadow':
                    cell.border_shadow = attributes.shadow;
                    break;
                case 'opacity':
                    cell.border_opacity = attributes.opacity;
                    break;
                case 'color':
                    cell.border_color = attributes.color;
                    break;
                case 'image':
                    cell.border_image = attributes.image;
                    break;
                case 'group_image':
                    cell.border_group_image = attributes.group_image;
                    break;
                case 'company_id':
                    cell.company_id = attributes.company_id;
                    break;
            }
        }

        return cell;
    };

    el.setColor = function (hsb, hex, rgb, element) {
        var attributes = {
            color: '#' + hex
        };

        var apply = parseInt($('input[name="apply_borders"]:checked').val());

        $(element).css('background-color', attributes.color);
        borderColor = attributes.color;
        update(attributes, apply);
    };

    el.showImages = function (gid, id) {
        var data = {
            group_id: gid,
            frame_id: id,
            images: []
        };

        var i;
        var images = frames[gid][id];
        for (i in images) {
            if (images.hasOwnProperty(i)) {
                data.images.push({
                    filename: images[i].name,
                    id: images[i].id,
                    company_id: images[i].company_id
                });
            }
        }

        var html = window.Mustache.render($('#frame-images-template').html(), data);
        $('.theme-images').empty();
        $('#theme-images-' + id).html(html);
    };

    el.hideImages = function () {
        $('.theme-images').empty();
    };

    el.showTab = function (element, id) {
        $('.dialogue-tab-link').removeClass('active');
        $('.dialogue-tab-content').removeClass('active');
        $(element).addClass('active');
        $('#border-tab-' + id).addClass('active');
    };

    el.setImage = function (groupId, frameId, id) {
        var item = frames[groupId][frameId][id];
        var url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/bc/frames/' + item.company_id + '/' + frameId + '/workimages/' + item.name;
        var image = new Image();

        image.onload = function () {
            var apply = parseInt($('input[name="apply_borders"]:checked').val());
            var attributes = {
                image: item.name,
                group_image: frameId,
                company_id: item.company_id,
                mask: item.mask
            };

            update(attributes, apply);

            el.workarea.render();
        };

        image.src = url;
    };

    el.removeImage = function () {
        var apply = parseInt($('input[name="apply_borders"]:checked').val());
        var attributes = {
            image: false,
            group_image: false
        };

        update(attributes, apply);

        el.workarea.render();
    };

    el.reset = function () {
        var attributes = {
            thickness: 2,
            shadow: 2,
            opacity: 1,
            color: '#ffffff'
        };

        var apply = parseInt($('input[name="apply_borders"]:checked').val());

        $('#border-color').colpickSetColor('ffffff', false).css('background-color', attributes.color);
        update(attributes, apply);
    };

    el.apply = function () {
        var attributes = {};
        var $elements = $('.apply-border');
        var apply = parseInt($('input[name="apply_borders"]:checked').val());

        var type, i;
        for (i = 0; i < $elements.length; i++) {
            type = $elements[i].getAttribute('data-type');
            switch (type) {
                case 'thickness':
                    attributes.thickness = parseInt($elements[i].value);
                    break;
                case 'shadow':
                    attributes.shadow = $elements[i].value;
                    break;
                case 'opacity':
                    attributes.opacity = $elements[i].value;
                    break;
            }
        }
        
        if (attributes.thickness === 0) {
            attributes.opacity = 0;
        }

        attributes.color = borderColor;

        update(attributes, apply);
    };

    el.showDialog = function () {
        el.dialog2.show('border-dialogue');
        init();
    };

    el.showProperty = function () {
        el.selection.panel('propertycell');
        init();
    };

    $(document).on('change', '.js-apply-border', function () {
        el.apply();
    });
    $(document).on('click', '.js-border-cancel', function () {
        el.reset();
    });
    $(document).on('click', '.js-frames-hide', function () {
        el.hideImages();
    });
    $(document).on('click', '.js-frame-set', function () {
        var element = $(this);
        el.setImage(element.attr('data-group'), element.attr('data-frame'), element.attr('data-id'));
    });
    $(document).on('click', '.js-frame-remove', function () {
        el.removeImage();
    });
    $(document).on('click', '.js-dialogue-tab-link', function () {
        el.showTab(this, $(this).attr('data-id'));
    });
};